/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of the DBN status table in master
 * data
 *
 *
 * Includes the ff:
 * - Name, collection name, label and other static values for the table
 * - Route definitions
 * - Privilege name for role restrictions
 * - Table columns indicated as fields
 * - Breadcrumbs definition
 *
 */
export default function (vm) {
  return {
    name: 'dbnStatusTable',
    collectionName: 'dbnStatus',
    dataView: 'default',
    label: 'DBN Status',
    tableHeader: 'DBN Status',
    route: {
      updateMultiple: 'dbnStatus',
      list: 'dbnStatus',
      deleteMultiple: 'dbnStatus',
      upload: 'dbnStatus'
    },
    hideSelect: true,
    privilege: 'canViewAllDbnStatus',
    fields: [
      {
        columnHeader: {
          sortable: true,
          text: 'DBN Status',
          value: 'value'
        }
      }
    ],
    breadcrumbs: {
      divider: '/',
      large: true,
      items: [
        {
          text: 'DBN Status'
        }
      ]
    }
  }
}
